import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-unsubscribe-user',
  templateUrl: './unsubscribe-user.component.html',
  styleUrls: ['./unsubscribe-user.component.sass']
})
export class UnsubscribeUserComponent implements OnInit {

  public selectedLanguageFlag: string = 'es';
  unsubscribed = false

  isLoading = true

  constructor(
    public dataService: DataService,
    public authService: AuthService,
    public router: Router,
    private route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private translate: TranslateService,) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      console.log(params)
      if (params.email && params.uid) {
        this.unsubscribeUser(params.email, params.uid)
      } else {
        this.isLoading = false
      }
    })
  }

  private async unsubscribeUser(email: string, uid: string) {
    let p = {}
    p['email'] = email
    p['uid'] = uid

    let u = await this.authService.getUser()
    console.log(u)

    if (!u) { 
      let login = await this.authService.anonymousLogin()
    }

    let sub = this.dataService.unsubscribeUser(p).subscribe((res: any) => {
      if (res) {
        this.unsubscribed = true
      }
      this.isLoading = false
    })
  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.selectedLanguageFlag = lang
  }
}
